
import { Box, Button, Grid, Typography } from "@mui/material";
import Logo from "../../images/logo_coloured.avif";

export default function Dashboard() {

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', padding: 5, minHeight: '80vh' }}>
      <Grid container spacing={3} sx={{ width: '100%', maxWidth: 820, justifyContent: 'center' }}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
            <Box
              component="img"
              src={Logo}
              alt="Gyrosa logo"
              sx={{
                // maxWidth: 220,
                width: '100%',
                height: 'auto',
                display: 'block',
              }}
            />
          </Box>
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Typography
            variant="h5"
            align="center"
            sx={{
              fontWeight: 700,
              letterSpacing: 0.5,
              textTransform: 'lowercase',
              color: 'text.primary',
            }}
          >
            gyrosa teammember app
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 8 }}>
          <Button
            variant="contained"
            fullWidth
            size="large"
            sx={{
              borderRadius: '15px',
              py: 1.5,
              textTransform: 'none',
              boxShadow: 'none',
            }}
            onClick={() => window.open('/docs/', '_blank', 'noopener,noreferrer')}
          >
            <Typography
              variant="body2"
              sx={{
                color: 'white',
                textAlign: 'center',
                textShadow: '2px 2px 4px rgba(0, 0, 0, 0.7)',
                lineHeight: 1.2,
              }}
            >
              see documentation
            </Typography>
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
}